import { BscChainId, Token } from 'types';
import config from 'config';

import aave from 'assets/img/tokens/aave.svg';
import ada from 'assets/img/tokens/ada.svg';
import bch from 'assets/img/tokens/bch.svg';
import beth from 'assets/img/tokens/beth.svg';
import bnb from 'assets/img/tokens/bnb.svg';
import btcb from 'assets/img/tokens/btcb.svg';
import busd from 'assets/img/tokens/busd.svg';
import cake from 'assets/img/tokens/cake.svg';
import dai from 'assets/img/tokens/dai.svg';
import doge from 'assets/img/tokens/doge.svg';
import dot from 'assets/img/tokens/dot.svg';
import eth from 'assets/img/tokens/eth.svg';
import fil from 'assets/img/tokens/fil.svg';
import link from 'assets/img/tokens/link.svg';
import ltc from 'assets/img/tokens/ltc.svg';
import luna from 'assets/img/tokens/luna.svg';
import matic from 'assets/img/tokens/matic.svg';
import sxp from 'assets/img/tokens/sxp.svg';
import trx from 'assets/img/tokens/trx.svg';
import tusd from 'assets/img/tokens/tusd.svg';
import usdc from 'assets/img/tokens/usdc.svg';
import usdt from 'assets/img/tokens/usdt.svg';
import ust from 'assets/img/tokens/ust.svg';
import vai from 'assets/img/tokens/vai.svg';
import vrt from 'assets/img/tokens/vrt.svg';
import xrp from 'assets/img/tokens/xrp.svg';
import xvs from 'assets/img/tokens/xvs.svg';
import umi from 'assets/img/tokens/umi.svg';
import cumi from 'assets/img/tokens/cumi.svg';
import hkt from 'assets/img/tokens/hkt.svg';
import dl from 'assets/img/tokens/dl.svg';
import brc from 'assets/img/tokens/bb.svg';

import TOKEN_ADDRESSES from '../../contracts/addresses/tokens.json';
import smc from '../../../assets/img/tokens/smc.svg';

export const MAINNET_TOKENS = {
  bnb: {
    id: 'bnb',
    symbol: 'BNB',
    decimals: 18,
    address: TOKEN_ADDRESSES.bnb[config.chainId],
    asset: bnb,
    isNative: true,
  } as Token,
  sxp: {
    id: 'sxp',
    symbol: 'SXP',
    decimals: 18,
    address: TOKEN_ADDRESSES.sxp[config.chainId],
    asset: sxp,
  } as Token,
  usdc: {
    id: 'usdc',
    symbol: 'USDC',
    decimals: 18,
    address: TOKEN_ADDRESSES.usdc[config.chainId],
    asset: usdc,
  } as Token,
  usdt: {
    id: 'usdt',
    symbol: 'USDT',
    decimals: 18,
    address: TOKEN_ADDRESSES.usdt[config.chainId],
    asset: usdt,
  } as Token,
  busd: {
    id: 'busd',
    symbol: 'BUSD',
    decimals: 18,
    address: TOKEN_ADDRESSES.busd[config.chainId],
    asset: busd,
  } as Token,
  xvs: {
    id: 'xvs',
    symbol: 'XVS',
    decimals: 18,
    address: TOKEN_ADDRESSES.xvs[config.chainId],
    asset: xvs,
  } as Token,
  btcb: {
    id: 'btcb',
    symbol: 'BTCB',
    decimals: 18,
    address: TOKEN_ADDRESSES.btcb[config.chainId],
    asset: btcb,
  } as Token,
  eth: {
    id: 'eth',
    symbol: 'ETH',
    decimals: 18,
    address: TOKEN_ADDRESSES.eth[config.chainId],
    asset: eth,
  } as Token,
  ltc: {
    id: 'ltc',
    symbol: 'LTC',
    decimals: 18,
    address: TOKEN_ADDRESSES.ltc[config.chainId],
    asset: ltc,
  } as Token,
  xrp: {
    id: 'xrp',
    symbol: 'XRP',
    decimals: 18,
    address: TOKEN_ADDRESSES.xrp[config.chainId],
    asset: xrp,
  } as Token,
  bch: {
    id: 'bch',
    symbol: 'BCH',
    decimals: 18,
    address: TOKEN_ADDRESSES.bch[config.chainId],
    asset: bch,
  } as Token,
  dot: {
    id: 'dot',
    symbol: 'DOT',
    decimals: 18,
    address: TOKEN_ADDRESSES.dot[config.chainId],
    asset: dot,
  } as Token,
  link: {
    id: 'link',
    symbol: 'LINK',
    decimals: 18,
    address: TOKEN_ADDRESSES.link[config.chainId],
    asset: link,
  } as Token,
  dai: {
    id: 'dai',
    symbol: 'DAI',
    decimals: 18,
    address: TOKEN_ADDRESSES.dai[config.chainId],
    asset: dai,
  } as Token,
  fil: {
    id: 'fil',
    symbol: 'FIL',
    decimals: 18,
    address: TOKEN_ADDRESSES.fil[config.chainId],
    asset: fil,
  } as Token,
  beth: {
    id: 'beth',
    symbol: 'BETH',
    decimals: 18,
    address: TOKEN_ADDRESSES.beth[config.chainId],
    asset: beth,
  } as Token,
  ada: {
    id: 'ada',
    symbol: 'ADA',
    decimals: 18,
    address: TOKEN_ADDRESSES.ada[config.chainId],
    asset: ada,
  } as Token,
  doge: {
    id: 'doge',
    symbol: 'DOGE',
    decimals: 8,
    address: TOKEN_ADDRESSES.doge[config.chainId],
    asset: doge,
  } as Token,
  matic: {
    id: 'matic',
    symbol: 'MATIC',
    decimals: 18,
    address: TOKEN_ADDRESSES.matic[config.chainId],
    asset: matic,
  } as Token,
  cake: {
    id: 'cake',
    symbol: 'CAKE',
    decimals: 18,
    address: TOKEN_ADDRESSES.cake[config.chainId],
    asset: cake,
  } as Token,
  aave: {
    id: 'aave',
    symbol: 'AAVE',
    decimals: 18,
    address: TOKEN_ADDRESSES.aave[config.chainId],
    asset: aave,
  } as Token,
  tusd: {
    id: 'tusd',
    symbol: 'TUSD',
    decimals: 18,
    address: TOKEN_ADDRESSES.tusd[config.chainId],
    asset: tusd,
  } as Token,
  trx: {
    id: 'trx',
    symbol: 'TRX',
    decimals: 18,
    address: TOKEN_ADDRESSES.trx[config.chainId],
    asset: trx,
  } as Token,
  vai: {
    id: 'vai',
    symbol: 'VAI',
    decimals: 18,
    address: TOKEN_ADDRESSES.vai[config.chainId],
    asset: vai,
  } as Token,
  vrt: {
    id: 'vrt',
    symbol: 'VRT',
    decimals: 18,
    address: TOKEN_ADDRESSES.vrt[config.chainId],
    asset: vrt,
  } as Token,
  ust: {
    id: 'ust',
    symbol: 'UST',
    decimals: 6,
    address: TOKEN_ADDRESSES.ust[config.chainId],
    asset: ust,
  } as Token,
  luna: {
    id: 'luna',
    symbol: 'LUNA',
    decimals: 6,
    address: TOKEN_ADDRESSES.luna[config.chainId],
    asset: luna,
  } as Token,
  umi: {
    id: 'umi',
    symbol: 'UMI',
    decimals: 18,
    address: TOKEN_ADDRESSES.umi[config.chainId],
    asset: umi,
  } as Token,
  smc: {
    id: 'smc',
    symbol: 'SMC',
    decimals: 18,
    address: TOKEN_ADDRESSES.smc[config.chainId],
    asset: smc,
  } as Token,
  cumi: {
    id: 'cumi',
    symbol: 'CUMI',
    decimals: 18,
    address: TOKEN_ADDRESSES.cumi[config.chainId],
    asset: cumi,
  } as Token,
  dl: {
    id: 'dl',
    symbol: 'DL',
    decimals: 18,
    address: TOKEN_ADDRESSES.dl[config.chainId],
    asset: dl,
  } as Token,
  brc: {
    id: 'brc',
    symbol: 'BRC',
    decimals: 18,
    address: TOKEN_ADDRESSES.brc[config.chainId],
    asset: brc,
  } as Token,
  hktlp: {
    id: 'hktlp',
    symbol: 'HKTLP',
    decimals: 18,
    address: TOKEN_ADDRESSES.hktlp[config.chainId],
    asset: hkt,
  } as Token,
};
